{"browse_shop":"Przeglądaj sklep","go_to_shop":"Przejdź do sklepu","no_orders_found":"Nie znaleziono żadnych zamówień","title":"Zamówienia"}